module.exports = __webpack_public_path__ + "img/honour-pic-11.c465523d.png";